'use client'

import { useFormikContext } from 'formik'
import styled from 'styled-components'

import { ErrorMessage } from '@syconium/little-miss-figgy/dist/components/Input/InputErrorMessage'
import { ScreenReaderOnly } from '@syconium/little-miss-figgy/dist/components/ScreenReaderOnly'

export const FormStatus = styled(({ className }: { className?: string }) => {
  const { status, touched } = useFormikContext()
  const displayStatus = touched && status

  return (
    <>
      {/* Visual only version */}
      {displayStatus ? (
        <ErrorMessage aria-hidden='true' className={className}>{`${status}`}</ErrorMessage>
      ) : null}

      {/* Screen reader only version (alerts need to be present at all times, prior to status being inserted) */}
      <ScreenReaderOnly>
        <span role='alert' aria-relevant='additions'>
          {displayStatus ? <span>{`${status}`}</span> : null}
        </span>
      </ScreenReaderOnly>
    </>
  )
})`
  margin-top: ${o => o.theme.spacing(4)};
  margin-bottom: ${o => o.theme.spacing(4)};
`
